<template>
  <div :class="!isDetail ? 'wrapper sidebar-collapsed' : ''" v-has-any-perms="allRolePerm">
    <portal-target
      name="layout-main"
      class="layout-main panel-scroll-full"
    >
      <div class="panel-list panel-fixed">
        <panel :title="panelTitle" :no-button="true">
          <!-- {{yardGantt}} -->
          <div class="col">
            <table class="table b-table table-hover">
              <thead class="">
                <tr class="">
                  <th class="table-b-table-default text-wrap">{{ $t('Report') }}</th>
                  <th class="table-b-table-default text-wrap text-right"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-has-perms="quotationRolePerm">
                  <td>{{ $t('Excel list of all quotations (construction sites and safety)')}}</td>
                  <td class="text-right">
                    <b-btn
                      v-has-perms="quotationRolePerm"
                      variant="outline-primary"
                      :title="'Download Excel' | translate"
                      @click.prevent="openQuotationsDialog('quotations')"
                    >
                      <i class='fas fa-file-excel'></i>
                    </b-btn>
                  </td>
                </tr>
                <tr v-has-perms="activeTrainingReportRolePerm">
                  <td>{{ $t('Excel training report (expired / expiring within four months / not performed) for active customers')}}</td>
                  <td class="text-right">
                    <b-btn
                      v-has-perms="activeTrainingReportRolePerm"
                      variant="outline-primary"
                      :title="'Download Excel' | translate"
                      @click.prevent="openTrainingReportDialog('activeTrainingReport')"
                    >
                      <i class='fas fa-file-excel'></i>
                    </b-btn>
                  </td>
                </tr>
                <tr v-has-perms="allTrainingReportRolePerm">
                  <td>{{ $t('Excel training report (expired / expiring within four months / not performed) for active and inactive customers')}}</td>
                  <td class="text-right">
                    <b-btn
                      v-has-perms="allTrainingReportRolePerm"
                      variant="outline-primary"
                      :title="'Download Excel' | translate"
                      @click.prevent="openTrainingReportDialog('allTrainingReport')"
                    >
                      <i class='fas fa-file-excel'></i>
                    </b-btn>
                  </td>
                </tr>
                <tr v-has-perms="expiringMedicalEligibilityRolePerm">
                  <td>{{ $t('Excel list of expired and soon-to-expire (within one month) medical fitness certificates for active and archived customers, based on a date to be specified by the requester')}}</td>
                  <td class="text-right">
                    <b-btn
                      v-has-perms="expiringMedicalEligibilityRolePerm"
                      variant="outline-primary"
                      :title="'Download Excel' | translate"
                      @click.prevent="openDownloadExpiredDialog('expiringMedicalEligibility')"
                    >
                      <i class='fas fa-file-excel'></i>
                    </b-btn>
                  </td>
                </tr>
                <tr v-has-perms="companyDocumentsRolePerm">
                  <td>{{ $t('current status of selected company documents in Excel')}}</td>
                  <td class="text-right">
                    <b-btn
                      v-has-perms="companyDocumentsRolePerm"
                      variant="outline-primary"
                      :title="'Download Excel' | translate"
                      @click.prevent="openDownloadDocumentsDialog('aziendale')"
                    >
                      <i class='fas fa-file-excel'></i>
                    </b-btn>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </panel>
      </div>
    </portal-target>
    <router-view />
    <DownloadQuotationsModal
      v-if="showQuotationsDialog"
      ref-id="modal-quotations"
      :no-close-on-backdrop="true"
      @close-modal="closeQuotationsModal"
      @generate-job="createJob"
    >
    </DownloadQuotationsModal>
    <DownloadExpiredDataModal
      v-if="showDownloadExpiredDialog"
      ref-id="modal-warning"
      :no-close-on-backdrop="true"
      confirm-btn-variant="primary"
      :confirm-btn-disabled="false"
      :body="warningDialogMessage"
      :button-confirm-text="'OK' | translate"
      :dataType="selectedDownloadType"
      @close-modal="closeDownloadExpiredModal"
      @generate-job="createJob"
    >
    </DownloadExpiredDataModal>
    <DownloadDocumentsDataModal
      v-if="showDownloadDocumentsDialog"
      ref-id="modal-warning"
      :no-close-on-backdrop="true"
      confirm-btn-variant="primary"
      :confirm-btn-disabled="false"
      :body="warningDialogMessage"
      :button-confirm-text="'OK' | translate"
      :documentType="selectedDownloadType"
      @close-modal="closeDownloadDocumentsModal"
      @generate-job="createJob"
    >
    </DownloadDocumentsDataModal>
    <DownloadTrainingReportModal
      v-if="showTrainingReportDialog"
      ref-id="modal-training-report"
      :no-close-on-backdrop="true"
      @close-modal="closeTrainingReportModal"
      @generate-job="createJob"
    >
    </DownloadTrainingReportModal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { TYPES as QUOTATION_TYPES } from '../../quotation/quotation/store'
import { TYPES as UPLOAD_DOCUMENT_TYPES } from '../upload-document/store'
import DownloadQuotationsModal from './DownloadQuotationsModal'
import DownloadExpiredDataModal from './DownloadExpiredDataModal'
import DownloadDocumentsDataModal from './DownloadDocumentsDataModal'
import DownloadTrainingReportModal from './DownloadTrainingReportModal'

export default {
  name: 'DownloadsList',
  props: {
    isDetail: { default: false }
  },
  components: {
    DownloadQuotationsModal,
    DownloadExpiredDataModal,
    DownloadDocumentsDataModal,
    DownloadTrainingReportModal
  },
  data () {
    const _data = {
      quotationRolePerm: ['quotation_quotation_generate_quotation_xslx_job'],
      activeTrainingReportRolePerm: ['document_uploaddocument_generate_active_training_report_job'],
      allTrainingReportRolePerm: ['document_uploaddocument_generate_all_training_report_job'],
      expiringMedicalEligibilityRolePerm: ['document_uploaddocument_generate_expiring_health_suitability_xlsx_job'],
      companyDocumentsRolePerm: ['document_uploaddocument_generate_company_documents_report_job'],
      showQuotationsDialog: false,
      selectedDownloadType: undefined,
      showDownloadExpiredDialog: false,
      showDownloadDocumentsDialog: false,
      showTrainingReportDialog: false
    }
    _data.allRolePerm = [..._data.quotationRolePerm, ..._data.activeTrainingReportRolePerm, ..._data.allTrainingReportRolePerm, ..._data.expiringMedicalEligibilityRolePerm, ..._data.companyDocumentsRolePerm]
    return _data
  },
  computed: {
    panelTitle () {
      return this.$t('Available reports')
    }
  },
  methods: {
    ...mapActions({
      generateQuotationXlsxJob: QUOTATION_TYPES.GENERIC.quotation.quotation.LIST.ACTIONS.generateQuotationXlsxJob,
      generateExpiringMedicalEligibilityTrainingXlsxJob: UPLOAD_DOCUMENT_TYPES.GENERIC.dashboard.uploaddocument.LIST.ACTIONS.generateExpiringMedicalEligibilityTrainingXlsxJob,
      generateCompanyDocumentsReportJob: UPLOAD_DOCUMENT_TYPES.GENERIC.dashboard.uploaddocument.LIST.ACTIONS.generateCompanyDocumentsReportJob,
      generateActiveTrainingReportJob: UPLOAD_DOCUMENT_TYPES.GENERIC.dashboard.uploaddocument.LIST.ACTIONS.generateActiveTrainingReportJob,
      generateAllTrainingReportJob: UPLOAD_DOCUMENT_TYPES.GENERIC.dashboard.uploaddocument.LIST.ACTIONS.generateAllTrainingReportJob
    }),
    openQuotationsDialog (downloadType) {
      this.$set(this, 'showQuotationsDialog', true)
      this.$set(this, 'selectedDownloadType', downloadType)
    },
    closeQuotationsModal () {
      this.$set(this, 'showQuotationsDialog', false)
      this.$set(this, 'selectedDownloadType', undefined)
    },
    openTrainingReportDialog (downloadType) {
      this.$set(this, 'showTrainingReportDialog', true)
      this.$set(this, 'selectedDownloadType', downloadType)
    },
    closeTrainingReportModal () {
      this.$set(this, 'showTrainingReportDialog', false)
      this.$set(this, 'selectedDownloadType', undefined)
    },
    openDownloadExpiredDialog (downloadType) {
      this.$set(this, 'showDownloadExpiredDialog', true)
      this.$set(this, 'selectedDownloadType', downloadType)
    },
    openDownloadDocumentsDialog (documentType) {
      this.$set(this, 'showDownloadDocumentsDialog', true)
      this.$set(this, 'selectedDownloadType', documentType)
    },
    closeDownloadExpiredModal () {
      this.$set(this, 'showDownloadExpiredDialog', false)
      this.$set(this, 'selectedDownloadType', undefined)
    },
    closeDownloadDocumentsModal () {
      this.$set(this, 'showDownloadDocumentsDialog', false)
      this.$set(this, 'selectedDownloadType', undefined)
    },
    createJob (evt) {
      const formData = Object.assign({}, evt)
      let filename
      if (this.selectedDownloadType === 'quotations') {
        filename = evt.date_q__gte
          ? `preventivi_completo_${evt.date_q__gte.replaceAll('-', '')}.xlsx`
          : 'preventivi_completo.xlsx'
        formData.file_name = filename
        this.generateQuotationXlsxJob(formData).then(
          () => {
            this.closeQuotationsModal()
          }
        )
      }
      if (this.selectedDownloadType === 'expiringMedicalEligibility') {
        filename = evt.date_end__gte
          ? `idoneita_medica_in_scadenza_${evt.date_end__gte.replaceAll('-', '')}.xlsx`
          : 'idoneita_medica_in_scadenza.xlsx'
        formData.file_name = filename
        this.generateExpiringMedicalEligibilityTrainingXlsxJob(formData).then(
          () => {
            this.closeDownloadExpiredModal()
          }
        )
      }
      if (this.selectedDownloadType === 'activeTrainingReport') {
        filename = 'formazione_clienti_attivi.xlsx'
        formData.file_name = filename
        this.generateActiveTrainingReportJob(formData).then(
          () => {
            this.closeTrainingReportModal()
          }
        )
      }
      if (this.selectedDownloadType === 'allTrainingReport') {
        filename = 'formazione_tutti_clienti.xlsx'
        formData.file_name = filename
        this.generateAllTrainingReportJob(formData).then(
          () => {
            this.closeTrainingReportModal()
          }
        )
      }
      if (this.showDownloadDocumentsDialog) {
        filename = 'documenti_aziendali.xlsx'
        formData.file_name = filename
        this.generateCompanyDocumentsReportJob(formData).then(
          () => {
            this.closeDownloadDocumentsModal()
          }
        )
      }
    }

  }
}
</script>
